















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Toggle extends Vue {
  @Prop({ type: Array, default: () => ['Active', 'In-active'] }) text!: string[];
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop(Boolean) readonly value!: boolean;

  get inputVal() {
    return this.value;
  }

  set inputVal(val) {
    this.$emit('input', val);
  }
}
